import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'linked-methods-autocomplete',
  templateUrl: './linked-methods-autocomplete.component.html',
  styleUrls: ['./linked-methods-autocomplete.component.scss'],
  standalone: false,
})
export class LinkedMethodsAutocompleteComponent implements OnInit {
  @Input() control: UntypedFormControl;
  @Input() options: string[];
  @Input() disabled = false;
  @Input() autofocus = false;
  autocompleteControl = new UntypedFormControl('');
  constructor() {}
  ngOnInit(): void {}

  onSelectTag(tag: string): void {
    const controlValues: string[] = Array.isArray(this.control.value) ? [...this.control.value] : [];
    controlValues.push(tag);
    const newValues = [...new Set(controlValues)];
    this.control.setValue(newValues);
    this.autocompleteControl.reset();
    this.autocompleteControl.setValue('');
  }

  onRemoveTag(tagIndex: number): void {
    const controlValues: string[] = Array.isArray(this.control.value) ? [...this.control.value] : [];
    controlValues.splice(tagIndex, 1);
    this.control.setValue(controlValues);
  }
}
